import { StyleSheet } from 'react-native';
import { neutrals, alert } from 'src/theme/colors';

export const styleShared = StyleSheet.create({
  details: {
    width: '100%',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
    gap: 24,
  },
  text: {
    color: neutrals.neutralGrays.tarmac,
    fontSize: 16,
    fontWeight: 400,
    lineHeight: 22,
    textAlign: 'center',
  },
  buttonText: {
    color: neutrals.white,
    fontSize: 18,
    fontWeight: 700,
    lineHeight: 27,
    textAlign: 'center',
  },
  errorWrapper: {
    height: 80,
  },
  textError: {
    textAlign: 'center',
    fontWeight: 400,
    fontSize: 16,
    lineHeight: 24,
    color: alert.alertRed,
  },
  textErrorBold: {
    textAlign: 'center',
    fontWeight: 700,
    fontSize: 16,
    lineHeight: 24,
    color: alert.alertRed,
  },
  loadingContentDetails: {
    width: 300,
    justifyContent: 'center',
    alignItems: 'center',
    gap: 16,
  },
  loadingContentText: {
    color: neutrals.neutralGrays.cement,
    fontSize: 24,
    fontWeight: 700,
    lineHeight: 31,
    textAlign: 'center',
  },
  textWrapper: {
    alignItems: 'center',
    gap: 11,
    width: '90%',
  },
});

export const stylesDesktop = StyleSheet.create({
  ...styleShared,
  button: {
    width: 280,
  },
  title: {
    fontWeight: 700,
    fontSize: 24,
    lineHeight: 31,
    color: neutrals.neutralGrays.graphite,
  },
  description: {
    fontWeight: 400,
    fontSize: 18,
    lineHeight: 27,
    color: neutrals.neutralGrays.graphite,
  },
  padding: {
    paddingTop: 16,
  },
});

export const stylesMobile = StyleSheet.create({
  ...styleShared,
  button: {
    width: 280,
  },
  title: {
    fontWeight: 700,
    fontSize: 20,
    lineHeight: 26,
    color: neutrals.neutralGrays.graphite,
    textAlign: 'center',
  },
  description: {
    fontWeight: 400,
    fontSize: 14,
    lineHeight: 20,
    color: neutrals.neutralGrays.graphite,
    textAlign: 'center',
  },
  padding: {
    paddingHorizontal: 16,
    paddingTop: 16,
    alignItems: 'center',
  },
});
